import { useUserPreferences } from 'lib/hooks/queries/user/useUserPreferences';

const useUserPreferencesState = (fields = []) => {
  const calendarEnabled = fields.includes('user_calendar');
  const generalEnabled = fields.includes('user_general');
  const notificationsEnabled = fields.includes('user_notifications');

  const {
    data: userCalendarData,
    isFetching: isUserCalendarFetching,
    error: userCalendarError
  } = useUserPreferences({
    params: { name: 'user_calendar' },
    dependencies: ['user_calendar'],
    options: { enabled: calendarEnabled }
  });

  const {
    data: userGeneralData,
    isFetching: isUserGeneralFetching,
    error: userGeneralError
  } = useUserPreferences({
    params: { name: 'user_general' },
    dependencies: ['user_general'],
    options: { enabled: generalEnabled }
  });

  const {
    data: userNotificationsData,
    isFetching: isUserNotificationsFetching,
    error: userNotificationsError
  } = useUserPreferences({
    params: { name: 'user_notifications' },
    dependencies: ['user_notifications'],
    options: { enabled: notificationsEnabled }
  });

  return {
    calendarPreferences: userCalendarData?.preferences?.value ?? {},
    generalPreferences: userGeneralData?.preferences?.value ?? {},
    notificationsPreferences: userNotificationsData?.preferences?.value ?? {},
    isLoading:
      (calendarEnabled && isUserCalendarFetching) ||
      (generalEnabled && isUserGeneralFetching) ||
      (notificationsEnabled && isUserNotificationsFetching),
    isFetching: isUserCalendarFetching || isUserGeneralFetching || isUserNotificationsFetching,
    error: userCalendarError || userGeneralError || userNotificationsError
  };
};

export default useUserPreferencesState;
